import React, { useEffect, useState } from 'react'
import { TrapezoidElement, TrapezoidWrapper } from './TrainStyles'
import { ReactComponent as TrainLost } from '../../../lib/assets/trainLost.svg'
import { ReactComponent as TrainWin } from '../../../lib/assets/trainWin.svg'
import { ReactComponent as TrainHistory } from '../../../lib/assets/trainHistory.svg'
import { Train_Props } from './interface'
import { SFXS } from '@orbitalgaming/games-frontend-library'

export default function Trapezoid({
  trainInfo,
  handleAbove,
  requestBetReply,
  handleRoundId,
  handlePopup,
  betId,
  audio,
}: Train_Props) {
  const [anim, setAnim] = useState<boolean>(false)

  const clickHandler = (id: string) => {
    !audio.isSoundOff && SFXS.goForwardSFX.play()
    handleRoundId(id)
    requestBetReply && requestBetReply(id.toString())
    setTimeout(() => {
      handlePopup('Bet Reply')
    }, 167)
  }

  useEffect(() => {
    if (trainInfo.length === 7) {
      setAnim(true)
      setTimeout(() => {
        trainInfo.shift()
        setAnim(false)
      }, 167)
    }
  }, [betId, trainInfo.length])

  return (
    <>
      <TrapezoidWrapper onClick={() => handleAbove('History')}>
        <TrapezoidElement className='history'>
          <TrainHistory />
          <p>Game History</p>
          <div className='gradient' />
        </TrapezoidElement>
      </TrapezoidWrapper>
      {trainInfo &&
        trainInfo.length &&
        trainInfo.map((el: any, id: number) => (
          <TrapezoidWrapper
            key={id}
            className={id === trainInfo.length - 1 ? 'data' : ''}
            onClick={() => clickHandler(el.roundId)}
            anim={anim}
            id={id}
          >
            <TrapezoidElement rotation={el.up === 0}>
              {el.profit > 0 ? <TrainWin /> : <TrainLost />}
              <p>{el.result.toFixed(2)}</p>
            </TrapezoidElement>
          </TrapezoidWrapper>
        ))}
    </>
  )
}
